<template>
  <div>
    <div id="chart" ref="main" style="width: 100%; height: 200px"></div>
    <div class="words">近7日订单时长</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      echartArea: null,
      pieCounts: 6,
    };
  },
  mounted() {
    this.initChart();
    this.pieInterval(this.pieCounts);
  },
  methods: {
    initChart() {
      this.echartArea = this.$echarts.init(this.$refs.main);
      // this.echartArea = this.$echarts.init(this.$refs.main);
      this.updatedChart();
    },
    // 饼图突出显示的定时器
    pieInterval(count) {
      setInterval(() => {
        this.echartArea.dispatchAction({
          type: "downplay",
          seriesIndex: [0, 1],
        });
        // this.echartArea.dispatchAction({
        //   type: "showTip",
        //   seriesIndex: 0,
        //   dataIndex: count % 6,
        // });
        this.echartArea.dispatchAction({
          type: "highlight",
          seriesIndex: [0, 1],
          dataIndex: count % 6,
        });
        count++;
      }, 1000);
    },
    updatedChart() {
      var data = [
        {
          name: "本科及以上",
          value: 13211,
        },
        {
          name: "高中",
          value: 42111,
        },
        {
          name: "初中及以下",
          value: 81711,
        },
        {
          name: "其他",
          value: 121711,
        },
      ];
      var arrName = getArrayValue(data, "name");
      var arrValue = getArrayValue(data, "value");
      var sumValue = eval(arrValue.join("+"));
      var objData = array2obj(data, "name");
      var optionData = getData(data);
      function getArrayValue(array, key) {
        var key = key || "value";
        var res = [];
        if (array) {
          array.forEach(function (t) {
            res.push(t[key]);
          });
        }
        return res;
      }

      function array2obj(array, key) {
        var resObj = {};
        for (var i = 0; i < array.length; i++) {
          resObj[array[i][key]] = array[i];
        }
        return resObj;
      }

      function getData(data) {
        var res = {
          series: [],
          yAxis: [],
        };
        for (let i = 0; i < data.length; i++) {
          res.series.push({
            name: "学历",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [85 - i * 15 + "%", 92 - i * 15 + "%"],
            center: ["45%", "50%"],
            label: {
              show: false,
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              borderWidth: 5,
            },
            data: [
              {
                value: data[i].value,
                name: data[i].name,
              },
              {
                value: sumValue - data[i].value,
                name: "",
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
            ],
          });
          res.series.push({
            name: "",
            type: "pie",
            silent: true,
            z: 1,
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [85 - i * 15 + "%", 92 - i * 15 + "%"],
            center: ["45%", "50%"],
            label: {
              show: false,
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              borderWidth: 5,
            },
            data: [
              {
                value: 7.5,
                itemStyle: {
                  color: "#029AFF",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
              {
                value: 2.5,
                name: "",
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
            ],
          });
          res.yAxis.push(
            data[i].name +
              "   " +
              ((data[i].value / sumValue) * 100).toFixed(2) +
              "%"
          );
        }
        return res;
      }

      const option = {
        // backgroundColor: "#fff",
        title: {
          text: "{a| }",
          // text:"",
          x: 180,
          y: 70,
          textStyle: {
            fontFamily: "MicrosoftYaHei-Bold, MicrosoftYaHei",
            fontWeight: "bold",
            // color: "#fff",
            rich: {
              a: {
                color: "#fff",
                fontSize: 16,
                height: 50,
                width: 50,
                backgroundColor: {
                  // image: require("../../assets/pgzl-turnover-1.png"),
                  image: require("../../../assets/icon-pie1.png"),
                },
                // padding: [130, 10, -30, 10],
              },
            },
          },
        },
        tooltip: {
          show: true,
          trigger: "item",
          formatter: "{a}<br>{b}:{c}({d}%)",
        },
        color: ["#FF8700", "#ffc300", "#00e473", "#009DFF"],
        grid: {
          top: "0%",
          bottom: "65%",
          left: "45%",
          containLabel: false,
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              inside: true,
              textStyle: {
                color: "#fff",
                fontSize: 10,
              },
              show: true,
            },
            data: optionData.yAxis,
          },
        ],
        xAxis: [
          {
            show: false,
          },
        ],
        series: optionData.series,
      };
      this.echartArea.setOption(option);
      // this.echartArea2.setOption(option)
    },
  },
};
</script>

<style lang="scss" scoped>
.words{
  padding-top: 10px;
  font-size: 21px;
  font-weight: bold;
  color: linear-gradient(180deg, #B3CCFF 0%, #36A3FF 100%);
  letter-spacing: 2px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/car-system/pie-center/left-pie.vue